import { gql } from '@apollo/client';
import RESOURCE_FRAGMENT from '../fragments/resource';
import RESOURCE_ASSETS_FRAGMENT from '../fragments/resource-assets';

const GET_RESOURCES_WITH_ASSETS = gql`
  query getResourcesWithAssets($where: ResourcesWhereInput) {
    resources(where: $where) {
      ...BaseResource
      ...BaseResourceAssets
    }
  }
  ${RESOURCE_FRAGMENT}
  ${RESOURCE_ASSETS_FRAGMENT}
`;

export default GET_RESOURCES_WITH_ASSETS;
